module.exports = __webpack_public_path__ + "static/WeChatQRCode-6945099ec30d48166f0620d01c90de57.jpg";